import styled from 'styled-components';
import { Box, TableContainer } from '@mui/material';

export const Container = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 12px;
  padding: 24px;
  min-width: 600px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #eee;
  }

  @media (max-width: 768px) {
    min-width: unset;
    width: 95vw;
    padding: 16px;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .MuiTableHead-root {
    .MuiTableCell-head {
      background: #f5f5f5;
      font-weight: 600;
      font-size: 13px;
      color: #333;
      white-space: nowrap;
    }
  }

  .MuiTableBody-root {
    .MuiTableRow-root {
      &:nth-of-type(odd) {
        background: #fafafa;
      }

      &:hover {
        background: #f0f7ff;
      }
    }

    .MuiTableCell-root {
      font-size: 13px;
      padding: 12px 16px;
    }
  }

  .change-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;

    .old-value {
      color: #d32f2f;
      text-decoration: line-through;
      font-size: 12px;
    }

    .arrow {
      color: #999;
      font-size: 12px;
    }

    .new-value {
      color: #2e7d32;
      font-weight: 600;
    }
  }
`;
